import React, { useState, useEffect, useRef } from "react";
import Icon from "../../components/ui/icon";
import "../../assets/styles/pages/publishers/wallet.css";
import SideNav from "../../components/layout/sideNav";
import { useToast } from "../../context/toastContext";
import { useNavigate } from "react-router-dom";
import api from "../../services/apiClient";
import moment from "moment-timezone";
import DOMPurify from "dompurify";
import { convertCurrency } from "../../utils/currencyConverter";
import { storageManager } from "../../utils/storageManager";
import { getTimezoneByCountry } from "../../utils/getTimezoneByCountry";

const WalletPage = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [isSideNavActive, setisSideNavActive] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("PublisherInfo")) || {}
  );
  const [tFetchStatus, setTFetchStatus] = useState("fetching_first");
  const [skip, setSkip] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [userVerified, setUserVerified] = useState(false);
  const [isLoadingInvoice, setisLoadingInvoice] = useState(true);
  const [invoices, setInvoices] = useState([]);
  const [pAmount, setpAmount] = useState("");
  const [withdrawlBtnD, setwithdrawlBtnD] = useState(false);
  const isLoadingMore = useRef(false);
  const limit = 20;
  const currency = storageManager.getCurrency();
  const country = userInfo?.country?.toLowerCase() || "india";

  useEffect(() => {
    const token = localStorage.getItem("aToken");
    if (!token) {
      navigate("/auth/login");
      return;
    }

    const validateUser = async () => {
      if (userVerified) return;

      api
        .get(`/api/publisher/info`)
        .then((response) => {
          fetchTransactions();
          setUserVerified(true);
          setUserInfo(response.data.data);
          localStorage.setItem(
            "PublisherInfo",
            JSON.stringify(response.data.data)
          );
          api.get("/api/invoice?limit=4").then((response) => {
            setisLoadingInvoice(false);
            if (response.data.length > 0) {
              setInvoices(response.data);
            }
          });
        })
        .catch((err) => {
          showToast({
            status: "error",
            message: err.response?.data?.message || "Login not found.",
          });
          navigate("/auth/login");
        });
    };

    const fetchTransactions = () => {
      if (tFetchStatus === "fetching" || !hasMore) return;
      if (tFetchStatus !== "fetching_first") setTFetchStatus("fetching");

      api
        .get(`/api/publisher/transactions?limit=${limit}&skip=${skip}`)
        .then((response) => {
          if (response.data.status) {
            const fetchedData = response.data.transactions;
            if (fetchedData.length < limit) {
              setHasMore(false);
              setTFetchStatus("not_needed");
            }

            isLoadingMore.current = false;

            setTransactions((prev) => [...prev, ...fetchedData]);
            setSkip((prevSkip) => prevSkip + limit);
            setTFetchStatus("success");
          } else {
            setTFetchStatus("failed");
          }
        })
        .catch((err) => {
          console.error(err);
          setTFetchStatus("failed");
        });
    };

    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 200 &&
        hasMore
      ) {
        if (tFetchStatus === "fetching_first") return;
        if (tFetchStatus === "not_needed") return;
        if (isLoadingMore.current) return;
        isLoadingMore.current = true;
        fetchTransactions();
      }
    };

    validateUser();

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, navigate, showToast, skip, tFetchStatus, userVerified]);

  const sanitizeInput = (value) => DOMPurify.sanitize(value);

  const handelAmoChange = (e) => {
    const value = sanitizeInput(e.target.value);
    setpAmount(value);
  };

  const handelWithdrawlBtn = () => {
    if (withdrawlBtnD) return;
    setwithdrawlBtnD(true);

    const tempAmount = sanitizeInput(pAmount);
    const tempAmount2 = convertCurrency(tempAmount, currency, "INR", true);
    const amount = Math.round(tempAmount2);
    console.log({ amount });

    if (!userInfo?.payoutInfo?.upiID) {
      showToast({
        status: "error",
        message: "Set payment address first.",
      });
      setwithdrawlBtnD(false);
      return;
    }
    if (!amount) {
      document.getElementById("amount").focus();
      setwithdrawlBtnD(false);
      return;
    }

    if (amount < 1000) {
      showToast({
        status: "error",
        message: `Minimum Amount is ${convertCurrency(1000, "INR", currency)}.`,
      });
      document.getElementById("amount").focus();
      setwithdrawlBtnD(false);
      return;
    }

    api
      .post("/api/invoice", { amount })
      .then((response) => {
        if (response.data.message === "min_amount_error") {
          showToast({
            status: "error",
            message: `Minimum Amount is ${convertCurrency(response.data.minAmount, "INR", currency)}.`,
          });
          document.getElementById("amount").focus();
          setwithdrawlBtnD(false);
          return;
        }
        showToast({
          status: response.data.status ? "success" : "error",
          message:
            response.data.message || response.data.status
              ? "Requested Successfully."
              : "Something went wrong.",
        });
        setwithdrawlBtnD(false);
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Something went wrong.",
        });
        setwithdrawlBtnD(false);
      });
  };

  return (
    <div className="wallet__page">
      <SideNav
        userName={userInfo.name}
        emailID={userInfo.email}
        active={isSideNavActive}
        campaignOpenInital={false}
        accManagerName={userInfo.adminInfo?.name}
        accManagerEmail={userInfo.adminInfo?.email}
      />
      <div
        onClick={() => setisSideNavActive(!isSideNavActive)}
        className={
          isSideNavActive ? "background-shadow active" : "background-shadow"
        }
      ></div>
      <main>
        <header className="desktop-header">
          <div>
            <h2>Wallet</h2>
            <p>Mange your earnings in more better and organized way. </p>
          </div>
        </header>

        <header className="mobile-header">
          <div>
            <h2>Wallet</h2>
          </div>
          <button
            className="nav-btn"
            onClick={() => setisSideNavActive(!isSideNavActive)}
          >
            {isSideNavActive ? (
              <Icon name="XMark" className="onLeft" />
            ) : (
              <Icon name="Bars3" className="onLeft" />
            )}
          </button>
        </header>

        <div className="main-container">
          <div className="payout-container">
            <div className="top">
              <div>
                <span>Available balance</span>
                <span
                  className={userInfo.balance === undefined ? "loading" : ""}
                >
                  {convertCurrency(userInfo?.balance, "INR", currency)}
                </span>
              </div>
              <Icon name="BankNotes" />
            </div>
            <div className="message">
              <Icon name="InformationCircle" />
              <span>
                Withdrawl's may take upto 2 days to reflect in your account.
              </span>
            </div>
            <div className="form-container">
              <div className="inp-box">
                <label htmlFor="upiid">UPI</label>
                <input
                  type="text"
                  placeholder="username@bank"
                  autoComplete="off"
                  value={userInfo?.payoutInfo?.upiID || "Not Set"}
                  id="upiid"
                  readOnly
                />
              </div>
              <div className="inp-box">
                <label htmlFor="amount">Amount</label>
                <input
                  type="number"
                  placeholder="Enter amount you want to withdraw"
                  autoComplete="off"
                  id="amount"
                  value={pAmount}
                  onChange={handelAmoChange}
                />
              </div>
              <button disabled={withdrawlBtnD} onClick={handelWithdrawlBtn}>
                {withdrawlBtnD ? "Generating Invoice" : "Withdrawl"}
                {withdrawlBtnD ? (
                  <Icon name="ArrowPath" className="spin" />
                ) : (
                  ""
                )}
              </button>
            </div>
          </div>
          <div
            className={`invoice-container ${!isLoadingInvoice && invoices.length < 4 ? "not-full" : ""
              }`}
          >
            {isLoadingInvoice && (
              <>
                <div className="invoice-box loading"></div>
                <div className="invoice-box loading"></div>
                <div className="invoice-box loading"></div>
                <div className="invoice-box loading"></div>
              </>
            )}
            {invoices && invoices?.length > 0 ? (
              invoices.map((invoice, index) => {
                return (
                  <div
                    className="invoice-box"
                    onClick={() => navigate(`/invoice/${invoice.invoiceId}`)}
                    key={invoice.invoiceId}
                  >
                    <div className="basic-info">
                      <span>Invoice #{invoice.invoiceId}</span>
                      <span>
                        {moment
                          .tz(invoice.withdrawalRequestedAt, getTimezoneByCountry(country))
                          .format("DD MMM YYYY, h:mm A")}
                      </span>
                    </div>
                    <span className="amount">
                      {convertCurrency(invoice.amount, "INR", currency)}
                    </span>
                  </div>
                );
              })
            ) : !isLoadingInvoice ? (
              <div className="empty-message">
                <Icon name="Document" />
                <h3>No Invoice Found.</h3>
                <p>
                  Looks like you have not requested any withdrawl yet, your
                  future invoices will appear here.
                </p>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>

        {(transactions && transactions.length > 0) ||
          tFetchStatus === "fetching_first" ? (
          <h2 className="rt-h2">Recent Transactions</h2>
        ) : (
          ""
        )}
        <div className="transaction-container">
          {tFetchStatus === "fetching_first" && (
            <>
              <div className="t-box loading"></div>
              <div className="t-box loading"></div>
              <div className="t-box loading"></div>
            </>
          )}
          {tFetchStatus === "failed" ? (
            <div className="load-message">
              <Icon name="ExclamationCircle" className="msg-icon" />
              <h3>Retrieval Failed</h3>
              <p>
                We encountered an error while trying to fetch your
                transaction's. Please try again later.
              </p>
            </div>
          ) : transactions && transactions.length > 0 ? (
            transactions.map((transaction, index) => {
              return (
                <div className="t-box" key={transaction.clickId}>
                  <div className="infos">
                    <img src="./DefaultImage.png" alt="Offer" />
                    <div>
                      <span>{transaction.campaignName}</span>
                      <span>
                        {moment
                          .tz(transaction.trackedAt, getTimezoneByCountry(country))
                          .format("DD MMM YYYY, h:mm A")}
                      </span>
                    </div>
                  </div>
                  <span className="amount">
                    +
                    {convertCurrency(
                      transaction.publisherProfit,
                      "INR",
                      currency
                    )}
                  </span>
                </div>
              );
            })
          ) : (
            ""
          )}
          {tFetchStatus === "fetching" && (
            <>
              <div className="load-message">
                <Icon name="ArrowPath" className="spin" />
                <h3>Fetching, Please wait.</h3>
                <p>We are fetching your other transactions please wait.</p>
              </div>
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default WalletPage;
